import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TemplateSettingsService } from '../template-settings.service';

import { DataService, Loading } from 'src/app/Services/Data/data.service';

@Component({
  selector: 'template-settings-form',
  templateUrl: './template-settings-form.component.html',
  styleUrls: ['./template-settings-form.component.sass']
})
export class TemplateSettingsFormComponent implements OnInit {
  isUserLoggedInSignNow = true;
  isTagBuilderExpanded = false;

  isFormDisabled: boolean;

  TemplateSettings: UntypedFormGroup;
  Roles: any = [];
  isEditMode: boolean;
  AnnotationConfig = {
    line_height: '',
    size: ''
  };
  sfTag: string = '';
  selectedRecordType: any;
  selectedRecordField = '';
  RecordFields: any = [];
  sfCurrObjMetaList: any = [];
  sObjects: any = [];
  is_template_settings_error = false;
  templateSettingsFormError = {
    title: 'Error',
    message: ''
  };

  errorFormMessages = {
    invalidEmail: 'Enter a valid email address.',
    emptyRoleFields: 'Enter values for name, email and order fields as required.',
    invalidOrderSequence: 'Ensure the signing order is in sequence and contains no gaps between signers.',
    invalidExpiration: 'Oops! Invalid expiration. Please enter a date from 3-180 days.',
    invalidReminder: 'Reminder duration cannot exceed the signing date of expiration.',
    invalidAnnotationConfig:
      'Annotation Config values are invalid. Please enter values that are greater than zero.',
    duplicatedEmailsWithOrders: "Make sure you've entered different emails for same signer order."
  };

  // Loading
  loading: Loading;

  // error
  error_message: string = '';

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private dataService: DataService,
    private templateSettingsService: TemplateSettingsService
  ) {
    this.loading = this.dataService.getLoading();
    this.isUserLoggedInSignNow = templateSettingsService.isUserLoggedInSignNow();
  }

  async ngOnInit() {
    this.sObjects = this.templateSettingsService.getSalesforceObjectList() || [];

    const currentTemplate = this.templateSettingsService.currentTemplate;

    if (currentTemplate) {
      if (
        !currentTemplate.cuda_signnow__Roles__c ||
        this.isJsonString(currentTemplate.cuda_signnow__Roles__c) === false
      ) {
        this.Roles = [];
        this.isEditMode = true;
      } else {
        try {
          currentTemplate.cuda_signnow__Roles__c = JSON.parse(currentTemplate.cuda_signnow__Roles__c);
        } catch {}

        if (currentTemplate.cuda_signnow__Roles__c) {
          for (let i = 0; i < currentTemplate.cuda_signnow__Roles__c.length; i++) {
            if (
              typeof currentTemplate.cuda_signnow__Roles__c[i].reminder === 'object' &&
              currentTemplate.cuda_signnow__Roles__c[i].reminder !== null
            ) {
              this.isFormDisabled = true;
            }
            this.Roles.push(this.setEditRoleForForm(currentTemplate.cuda_signnow__Roles__c[i]));
            this.removeEmptyProperty(this.Roles[this.Roles.length - 1], 'expiration');
            this.removeEmptyProperty(this.Roles[this.Roles.length - 1], 'reminder');
          }
        }
      }

      if (currentTemplate.cuda_signnow__Annotation_Config__c) {
        try {
          const temp = '{' + currentTemplate.cuda_signnow__Annotation_Config__c + '}';
          this.AnnotationConfig = JSON.parse(temp).annotation_config;
        } catch {}
      }

      this.isEditMode = true;
      this.TemplateSettings = this.fb.group({
        Id: currentTemplate.Id,
        TemplateName: [currentTemplate.Name, [Validators.required]],
        Roles: this.fb.array(this.initAllRolesForForm()),
        Subject: [currentTemplate.cuda_signnow__subject__c],
        Body: [currentTemplate.cuda_signnow__Body__c],
        Name: [currentTemplate.cuda_signnow__Document_Name__c],
        SkipToEnd: currentTemplate.cuda_signnow__Skip_to_End__c,
        TemplateId: currentTemplate.cuda_signnow__Template_Id__c,
        AutomaticallySend: currentTemplate.cuda_signnow__Automatically_Send__c,
        HideAdvancedSettings: currentTemplate.cuda_signnow__Hide_Adv_Set__c,
        AnnotationConfig: this.fb.group({
          size: [this.AnnotationConfig.size, [Validators.min(0)]],
          line_height: [this.AnnotationConfig.line_height, [Validators.min(0)]]
        })
      });
    } else {
      this.isEditMode = false;
      this.TemplateSettings = this.fb.group({
        Id: '',
        TemplateName: ['', [Validators.required]],
        Roles: this.fb.array(this.initAllRolesForForm()),
        Subject: [''],
        Body: [''],
        Name: [''],
        SkipToEnd: false,
        TemplateId: '',
        AutomaticallySend: false,
        HideAdvancedSettings: false,
        AnnotationConfig: this.fb.group({
          size: [this.AnnotationConfig.size, [Validators.min(0)]],
          line_height: [this.AnnotationConfig.line_height, [Validators.min(0)]]
        })
      });
    }

    if (!this.sObjects.length) {
      this.templateSettingsService.getRecordFieldsFromSalesforce().subscribe((result) => {
        this.sObjects = result;
        if (result && result.length) {
          this.templateSettingsService.setSalesforceObjectList(result);
        }
      });
    }
  }

  initAllRolesForForm() {
    return this.Roles.map((role) => {
      return this.fb.group(role);
    });
  }

  // Preloading and Selecting Record Types
  async selectRecordType(type) {
    this.selectedRecordField = '';
    console.log('Selected Record Type: ', type);

    if (type) {
      this.templateSettingsService.getListRecordFields(type).subscribe(
        (result) => {
          this.selectedRecordType = type;
          this.RecordFields = result;
        },
        () => (this.RecordFields = [])
      );
    } else {
      this.selectedRecordType = null;
      this.RecordFields = [];
      this.selectRecordField('');
    }
  }

  selectRecordField(field) {
    this.selectedRecordField = field;
    this.sfTag = field ? `{${this.selectedRecordType}.${field}}` : '';
  }

  private setEditRoleForForm(_role: any) {
    if (_role === null) {
      return {
        order: [1, [Validators.required, Validators.min(1)]],
        name: ['', [Validators.required]],
        email: ['', [Validators.required]],
        password: '',
        reminder: ['0', [Validators.min(0)]],
        expiration: ['30', [Validators.min(3), Validators.max(180)]],
        allow_forwarding: 'no',
        is_allow_forwarding: false // helper property (using for checkbox on html) for allow_forwarding property, we no need to save it in JSON
      };
    } else {
      const expirationValue = _role.expiration
        ? _role.expiration.toString()
        : _role.expiration_days
        ? _role.expiration_days.toString()
        : '30';

      return {
        order: [Number(_role.order).toString(), [Validators.required, Validators.min(1)]],
        name: [_role.name, [Validators.required]],
        email: [_role.email, [Validators.required]],
        password: _role.password,
        reminder: [Number(_role.reminder).toString(), [Validators.min(0), Validators.max(180)]],
        expiration: [expirationValue, [Validators.min(3), Validators.max(180)]],
        allow_forwarding: _role.allow_forwarding,
        is_allow_forwarding: _role.allow_forwarding === 'yes' // helper property (using for checkbox on html) for allow_forwarding property, we no need to save it in JSON
      };
    }
  }

  addRole() {
    const control = <UntypedFormArray>this.TemplateSettings.controls['Roles'];
    const roleItem = this.setEditRoleForForm(null);
    this.Roles.push(roleItem);
    control.push(this.fb.group(roleItem));
  }

  deleteRole(index) {
    this.Roles.splice(index, 1);

    const control = <UntypedFormArray>this.TemplateSettings.controls['Roles'];
    control.removeAt(index);
  }

  // error handler
  private validateRoleWithErrorMessage(role: any) {
    if (!this.isRequiredValuesFilledInRole(role.order, role.name, role.email)) {
      this.setErrorAndShowError(this.errorFormMessages.emptyRoleFields);
      return false;
    }
    if (!this.isEmailValid(role.email)) {
      this.setErrorAndShowError(this.errorFormMessages.invalidEmail);
      return false;
    }
    if (!this.isNoDuplicateEmails(role, this.TemplateSettings.value.Roles)) {
      this.setErrorAndShowError(this.errorFormMessages.duplicatedEmailsWithOrders);
      return false;
    }
    if (!this.isExpirationValid(role.expiration)) {
      this.setErrorAndShowError(this.errorFormMessages.invalidExpiration);
      return false;
    }
    if (!this.isReminderValid(role.expiration, role.reminder)) {
      this.setErrorAndShowError(this.errorFormMessages.invalidReminder);
      return false;
    }

    return true;
  }

  // methods to check validity
  isRequiredValuesFilledInRole(order: any, name: any, email: any) {
    return !!(order > 0 && name && email);
  }

  isEmailValid(email) {
    if (this.isValidTag(email)) {
      return true;
    }
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  isValidTag(value) {
    try {
      const re = /{([^}]+)}/g;
      const result = re.exec(value)[0];
      const match = result.split('.');
      if (match[0].length > 0 && match[1].length > 0) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  isNoDuplicateEmails(role, allRoles) {
    if (allRoles.length === 0) {
      return true;
    }
    const currentEmail = role.email;
    const currentOrder = role.order;
    const otherEmails = [];
    const otherOrders = [];

    for (let i = 0; i < allRoles.length; i++) {
      if (role !== allRoles[i]) {
        otherEmails.push(allRoles[i].email);
        otherOrders.push(Number(allRoles[i].order));
      }
    }

    if (otherEmails.includes(currentEmail)) {
      // is same email exist in the list
      if (!this.isOrderValidForSameEmail(currentOrder, currentEmail, allRoles)) {
        return false;
      }
    }

    return true;
  }

  isOrderValidForSameEmail(targetOrder, targetEmail, Roles) {
    let countOfSameEmailWithSameOrder = 0;

    for (let i = 0; i < Roles.length; i++) {
      if (Roles[i].email === targetEmail && Roles[i].order === targetOrder) {
        ++countOfSameEmailWithSameOrder;
      }
    }

    return countOfSameEmailWithSameOrder < 2;
  }

  isExpirationValid(expiration) {
    expiration = Number(expiration);
    return !(expiration < 3 || expiration > 180);
  }

  isReminderValid(expiration, reminder) {
    expiration = Number(expiration);
    reminder = Number(reminder);
    return !(reminder > expiration || reminder < 0);
  }

  isAnnotationConfigValid() {
    return this.TemplateSettings.controls['AnnotationConfig']['valid'];
  }

  isOrdersSequenceValid(Roles) {
    const ordersSet = new Set();
    let uniqueOrdersArray;

    for (let i = 0; i < Roles.length; i++) {
      ordersSet.add(Number(Roles[i].order));
    }

    uniqueOrdersArray = Array.from(ordersSet);
    uniqueOrdersArray.sort();

    for (let i = 0; i < uniqueOrdersArray.length; i++) {
      if (uniqueOrdersArray[i] !== i + 1) {
        return false;
      }
    }

    return true;
  }

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch {
      return false;
    }
    return true;
  }

  copyTag(index) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', index);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }

  backButton() {
    this.isEditMode = null;
    this.templateSettingsService.resetTemplate();
    this.router.navigate(['/template_settings']);
  }

  removeEmptyProperty(obj, propertyName) {
    if (!obj[propertyName]) {
      delete obj[propertyName];
    }
    return obj;
  }

  submitForm() {
    const dataTplSettings = Object.assign({}, this.TemplateSettings.value);

    if (!dataTplSettings.Roles) {
      dataTplSettings.Roles = '';
    }

    for (let i = 0; i < dataTplSettings.Roles.length; i++) {
      const roleItem = dataTplSettings.Roles[i];
      this.removeEmptyProperty(roleItem, 'password');
      this.removeEmptyProperty(roleItem, 'expiration');
      this.removeEmptyProperty(roleItem, 'reminder');
      roleItem.allow_forwarding = roleItem.is_allow_forwarding ? 'yes' : 'no';

      try {
        delete roleItem.is_allow_forwarding; // deleting helper property
      } catch {}

      if (!this.validateRoleWithErrorMessage(roleItem)) {
        return;
      }
    }

    if (!this.isOrdersSequenceValid(dataTplSettings.Roles)) {
      this.setErrorAndShowError(this.errorFormMessages.invalidOrderSequence);
      return false;
    }

    if (!this.isAnnotationConfigValid()) {
      this.setErrorAndShowError(this.errorFormMessages.invalidAnnotationConfig);
      return false;
    }

    // if (this.chosenPreselectedDocument && this.chosenPreselectedDocument.id) {
    //   dataTplSettings.TemplateId = this.chosenPreselectedDocument.id;
    // } else if (dataTplSettings.TemplateId) {
    //   if (this.chosenTplType !== this.templateInputTypes.id) {
    //     const template = this.templateSuggestionList.find(tpl => tpl.label === dataTplSettings.TemplateId);
    //     dataTplSettings.TemplateId = template ? template.id : '';
    //   }
    // } else {
    //   dataTplSettings.TemplateId = '';
    // }

    this.updateLoading(true, 'Saving Document Flow...');
    if (this.isEditMode) {
      this.templateSettingsService
        .updateTemplateSettings(dataTplSettings)
        .pipe(
          finalize(() => {
            this.hideLoading();
            this.templateSettingsService.resetTemplate();
          })
        )
        .subscribe(
          () => {
            this.templateSettingsService.resetTemplate();
            this.TemplateSettings = null;
            this.isEditMode = null;
            this.router.navigate(['/template_settings']);
          },
          () => this.errorSaveFormHandler()
        );
    } else {
      this.templateSettingsService
        .createNewTemplate(dataTplSettings)
        .pipe(finalize(() => this.hideLoading()))
        .subscribe(
          () => {
            this.TemplateSettings = null;
            this.isEditMode = null;
            this.router.navigate(['/template_settings']);
          },
          () => this.errorSaveFormHandler()
        );
    }
  }

  errorSaveFormHandler() {
    this.updateError('Something went wrong. Resend a form or reload the page.');
    this.openModal();
    this.templateSettingsFormError.message = 'Something went wrong. Try to resend form or reload page.';
  }

  setErrorAndShowError(errorMessage: string) {
    this.templateSettingsFormError.message = errorMessage;
    this.openModal();
  }

  openModal() {
    this.is_template_settings_error = true;
  }

  closeModal() {
    this.is_template_settings_error = false;
  }

  clearErrors() {
    this.error_message = '';
  }
  updateError(msg: string) {
    this.error_message = msg;
  }

  updateLoading(loadingStatus: boolean = false, msg: string = '') {
    this.loading.update(loadingStatus, msg);
  }
  hideLoading() {
    this.loading.hide();
  }
}
